export default {
	// 下拉 接口状态
	stateList: [
		{ value: 0, label: '停用' },
		{ value: 1, label: '正常' }
	],
	// 下拉 权限使用
	usePermList: [
		{ value: 0, label: '内部' },
		{ value: 1, label: '外部' }
	],
	// 下拉 调用类别
	invokeTypeList: [
		{ value: '1001', label: '通信类' },
		{ value: '1002', label: '司法类' },
		{ value: '1003', label: '征信类' },
		{ value: '1004', label: '运营类' },
		{ value: '1005', label: '财务类' }
	],
	// 下拉 api请求方式
	requestMethodList: [
		{ value: 0, label: 'POST' },
		{ value: 1, label: 'GET' },
		{ value: 2, label: 'PUT' },
		{ value: 3, label: 'DELETE' },
		{ value: 4, label: 'HEAD' },
		{ value: 5, label: 'OPTIONS' },
		{ value: 6, label: 'PATCH' }
	],
	// 下拉 是否
	isList: [
		{ value: 0, label: '否' },
		{ value: 1, label: '是' }
	],
	// 下拉 使用与
	useBeList: [
		{ value: 0, label: 'web' },
		{ value: 1, label: '移动端web' },
		{ value: 2, label: '电脑端web' }
	]
}